module.exports = __webpack_public_path__ + "img/etax-inet.f55d703.webp";